module.exports = __webpack_public_path__ + "img/2.83e9ae7a.png";